import axios from "@/components/api/axios";

const list = request => {
    return axios.post(
        '/payment/list',
        request).then(response => response.data)
}

const get = request => {
    return axios.post(
        '/payment/get',
        request).then(response => response.data)
}

export default {
    get,
    list
}